// extracted by mini-css-extract-plugin
module.exports = {"spinner":"orQl5eJa","rotate":"BJydefvK","accent":"mrgUaUpc","extraSmall":"lIULtwdO","small":"hNnpPT44","large":"RrePQMbf"};